<template>
    <asli-accordion-item :sectionName="sectionName">
        <template #header>
            <div class="flex justify-between items-center w-full">
                <h3 class="text-base sm:text-lg font-bold text-mediumGreen my-3">{{ title }}</h3>
            </div>
        </template>
        <template #header-actions>
            <div class="flex justify-end px-5 py-1" v-if="!editingDisabled">
                <asli-button-link
                    :id="id"
                    class="text-xs sm:text-sm text-mediumGreen font-normal underline cursor-pointer"
                    @click="$emit('navigate', sectionName)"
                >
                    Edit {{ title }}
                </asli-button-link>
            </div>
        </template>
        <div class="">
            <div class="grid grid-cols-1 xs:grid-cols-[1fr,1fr] gap-3 xs:gap-4">
                <template v-for="field in fieldsToShow" :key="field.key">
                    <p class="font-semibold sm:font-bold my-0 text-xs sm:text-base">{{ field.label }}</p>
                    <p class="font-light my-0 text-xs sm:text-base">
                        {{ field.isCurrency && "€" }}{{ data[field.key] }}
                    </p>
                </template>
            </div>
        </div>
    </asli-accordion-item>
</template>

<script lang="ts" setup>
import { AsliAccordionItem, AsliButtonLink } from "@mbs-npm/anpost-ui";
import { computed } from "vue";

const props = defineProps<{
    title: string;
    sectionName: string;
    fields: Array<{
        label: string;
        key: string;
        condition?: string;
        isCurrency?: boolean;
    }>;
    data: Record<string, number | string | null | undefined>;
    editingDisabled: boolean;
}>();

const id = `edit-section-${props.sectionName}`;

const fieldsToShow = computed(() => props.fields.filter(field => !field.condition || props.data[field.condition]));

defineEmits<{
    (e: "navigate", section: string): void;
}>();
</script>
